"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Direction;
(function(Direction) {
  Direction["FORWARD"] = "forward";
  Direction["BACKWARD"] = "backward";
})((Direction = exports.Direction || (exports.Direction = {})));
var SortOrder;
(function(SortOrder) {
  SortOrder["ASC"] = "asc";
  SortOrder["DESC"] = "desc";
})((SortOrder = exports.SortOrder || (exports.SortOrder = {})));
var ContextCategory;
(function(ContextCategory) {
  ContextCategory["WORKFLOW"] = "workflow";
  ContextCategory["EXECUTION"] = "execution";
  ContextCategory["SCHEDULE"] = "schedule";
  ContextCategory["NONE"] = "none";
})(
  (ContextCategory = exports.ContextCategory || (exports.ContextCategory = {}))
);
var WorkflowContext;
(function(WorkflowContext) {
  WorkflowContext["RUN"] = "run";
  WorkflowContext["EDIT"] = "edit";
  WorkflowContext["VIEW_EXECUTIONS"] = "view-execution";
  WorkflowContext["VIEW_POLICY"] = "view-policy";
  WorkflowContext["DELETE"] = "delete";
  WorkflowContext["TOGGLE_ACTIVE"] = "toggle-active";
  WorkflowContext["SHARE"] = "share";
})(
  (WorkflowContext = exports.WorkflowContext || (exports.WorkflowContext = {}))
);
var ExecutionContext;
(function(ExecutionContext) {
  ExecutionContext["VIEW_DETAILS"] = "view-details";
  ExecutionContext["VIEW_POLICY"] = "view-policy";
  ExecutionContext["SHARE"] = "share";
})(
  (ExecutionContext =
    exports.ExecutionContext || (exports.ExecutionContext = {}))
);
var ScheduleContext;
(function(ScheduleContext) {
  ScheduleContext["EDIT"] = "edit";
  ScheduleContext["PARK"] = "park";
  ScheduleContext["UN_PARK"] = "un-park";
  ScheduleContext["VIEW_HISTORY"] = "view-history";
  ScheduleContext["SKIP"] = "skip";
  ScheduleContext["TEST"] = "test";
  ScheduleContext["LINK"] = "link";
  ScheduleContext["DELETE"] = "delete";
  ScheduleContext["TOGGLE_ACTIVE"] = "toggle-active";
})(
  (ScheduleContext = exports.ScheduleContext || (exports.ScheduleContext = {}))
);
var ActionModals;
(function(ActionModals) {
  ActionModals["LINK_FIX"] = "link-fix";
  ActionModals["WORKFLOW_CLONE"] = "workflow-clone";
  ActionModals["WORKFLOW_POLICY"] = "workflow-policy";
  ActionModals["WORKFLOW_SHARE"] = "workflow-share";
  ActionModals["ADOPT_TEMPLATE"] = "adopt-template";
  ActionModals["PARAMS_EDITOR"] = "params-editor";
  ActionModals["WORKFLOW_ACTION_DISABLE"] = "workflow-action-disable";
  ActionModals["WORKFLOW_ACTION_ENABLE"] = "workflow-action-enable";
})((ActionModals = exports.ActionModals || (exports.ActionModals = {})));
var Events;
(function(Events) {
  Events["REGION_CHANGE"] = "onRegionChange";
  Events["ACCOUNT_CHANGE"] = "onAccountChange";
  Events["FILTER_CHANGE"] = "onFilterChange";
  Events["SEARCH_CHANGE"] = "onSearchChange";
  Events["PARAM_CHANGE"] = "onParamsChange";
})((Events = exports.Events || (exports.Events = {})));
var EditorType;
(function(EditorType) {
  EditorType["TEXT"] = "text";
  EditorType["DROPDOWN"] = "dropdown";
})((EditorType = exports.EditorType || (exports.EditorType = {})));
//# sourceMappingURL=types.js.map
